<template>
  <v-dialog
    v-model="dialogCambiosPersonal.estatus"
    max-width="1200px"
    transition="dialog-transition"
    scrollable
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        Cambios de personal por grupo
        <v-spacer></v-spacer>
        <span class="text-caption grey--text mr-2" v-if="cicloLabel">
          {{ cicloLabel }} · Semana {{ semana }}
        </span>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-2" dense>
          <v-col cols="12" md="3">
            <div class="text-caption grey--text">Obligaciones</div>
            <div class="text-h6">{{ resumen.obligaciones }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="text-caption grey--text">Clases correctas</div>
            <div class="text-h6 green--text text--darken-2">{{ resumen.correctas }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="text-caption grey--text">Cambios</div>
            <div class="text-h6 red--text text--darken-2">{{ resumen.cambios }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="text-caption grey--text">% cumplimiento</div>
            <div class="text-h6">{{ resumen.pctFmt }}%</div>
          </v-col>
        </v-row>

        <p class="text-caption grey--text mb-3">
          Compara el teacher oficial del grupo (resuelto a id_usuario, igual que en producción/KPI)
          contra el teacher del slot. Solo lista cambios reales. Sábado y domingo = <b>1 clase</b>
          aunque tengan varios bloques. Respeta filtros. Excluye APOYO.
        </p>

        <v-row class="mb-2" dense>
          <v-col cols="12" md="6" lg="4">
            <v-text-field
              v-model="search"
              label="Buscar"
              dense
              filled
              hide-details
              single-line
              clearable
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="filasCambios"
          class="elevation-0"
          dense
          height="480"
          fixed-header
          :search="search"
          :item-key="itemKey"
          :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
        >
          <template v-slot:item.escuela="{ item }">
            <v-chip x-small :color="item.escuela === 'FAST' ? 'pink lighten-4' : 'light-blue lighten-4'" label>
              {{ item.escuela }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-btn color="black" small tile dark @click="dialogCambiosPersonal.estatus = false">
          <v-icon small left>mdi-close</v-icon>
          Cerrar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="green"
          small
          tile
          dark
          :disabled="!filasCambios.length"
          @click="exportar"
        >
          <v-icon small left>mdi-microsoft-excel</v-icon>
          Excel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import funcionesExcel from '@/mixins/funcionesExcel'

const DIA_LABEL = {
  lunes: 'Lunes',
  martes: 'Martes',
  miercoles: 'Miércoles',
  jueves: 'Jueves',
  viernes: 'Viernes',
  sabado: 'Sábado',
  domingo: 'Domingo',
}

const SABADO_NO_TEENS_POR_SEMANA = [
  [
    { tf: 'id_teacher', s: 'lu1' }, { tf: 'id_teacher', s: 'ma1' }, { tf: 'id_teacher', s: 'mi1' },
    { tf: 'id_teacher_2', s: 'ju1' }, { tf: 'id_teacher_2', s: 'vi1' },
  ],
  [
    { tf: 'id_teacher', s: 'lu2' }, { tf: 'id_teacher', s: 'ma2' }, { tf: 'id_teacher', s: 'mi2' },
    { tf: 'id_teacher_2', s: 'ju2' }, { tf: 'id_teacher_2', s: 'vi2' },
  ],
  [
    { tf: 'id_teacher', s: 'lu3' }, { tf: 'id_teacher', s: 'ma3' }, { tf: 'id_teacher', s: 'mi3' },
    { tf: 'id_teacher_2', s: 'ju3' }, { tf: 'id_teacher_2', s: 'vi3' },
  ],
  [
    { tf: 'id_teacher', s: 'lu4' }, { tf: 'id_teacher', s: 'ma4' }, { tf: 'id_teacher', s: 'mi4' },
    { tf: 'id_teacher_2', s: 'ju4' }, { tf: 'id_teacher_2', s: 'vi4' },
  ],
  [
    { tf: 'id_teacher', s: 'lu5' }, { tf: 'id_teacher', s: 'ma5' }, { tf: 'id_teacher', s: 'mi5' },
    { tf: 'id_teacher_2', s: 'ju5' }, { tf: 'id_teacher_2', s: 'vi5' },
  ],
]

const DOMINGO_NO_TEENS = [
  ['id_teacher', 'lu1'], ['id_teacher', 'ma1'], ['id_teacher', 'mi1'], ['id_teacher_2', 'ju1'], ['id_teacher_2', 'vi1'],
  ['id_teacher', 'lu2'], ['id_teacher_2', 'ju2'], ['id_teacher_2', 'ju3'], ['id_teacher', 'lu4'], ['id_teacher_2', 'ju4'],
  ['id_teacher', 'lu5'], ['id_teacher', 'ma5'], ['id_teacher', 'mi5'], ['id_teacher_2', 'ju5'], ['id_teacher_2', 'vi5'],
]

function idNum (v) {
  if (v == null || v === '' || String(v).toUpperCase() === 'SIN TEACHER') return 0
  const n = Number(v)
  return Number.isNaN(n) ? 0 : n
}

function campoOficial (grupo, tf) {
  if (tf === 'id_teacher') {
    return idNum(grupo.id_teacher != null ? grupo.id_teacher : grupo.id_Teacher)
  }
  const alt =
    grupo.id_teacher_2 != null
      ? grupo.id_teacher_2
      : (grupo.id_Teacher_2 != null ? grupo.id_Teacher_2 : grupo.idTeacher2)
  return idNum(alt)
}

function semanaDesdeSlot (slot) {
  const m = String(slot).match(/(\d+)$/)
  return m ? Number(m[1]) : null
}

function construirChequeos (grupo) {
  const checks = []
  const esTeens = /TEENS/.test(grupo.grupo || '')
  for (let sem = 1; sem <= 5; sem++) {
    if (grupo.lunes == 1) checks.push({ dia: 'lunes', tf: 'id_teacher', slot: `lu${sem}` })
    if (grupo.martes == 1) checks.push({ dia: 'martes', tf: 'id_teacher', slot: `ma${sem}` })
    if (grupo.miercoles == 1) checks.push({ dia: 'miercoles', tf: 'id_teacher', slot: `mi${sem}` })
    if (grupo.jueves == 1) checks.push({ dia: 'jueves', tf: 'id_teacher_2', slot: `ju${sem}` })
    if (grupo.viernes == 1) checks.push({ dia: 'viernes', tf: 'id_teacher_2', slot: `vi${sem}` })
  }
  if (grupo.sabado == 1) {
    if (esTeens) {
      for (let sem = 1; sem <= 4; sem++) {
        checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `lu${sem}` })
        checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `ma${sem}` })
      }
      checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'ju5' })
      checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'vi5' })
    } else {
      for (const slots of SABADO_NO_TEENS_POR_SEMANA) {
        for (const { tf, s } of slots) checks.push({ dia: 'sabado', tf, slot: s })
      }
    }
  }
  if (grupo.domingo == 1) {
    if (esTeens) {
      for (let sem = 1; sem <= 4; sem++) {
        checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `lu${sem}` })
        checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `ma${sem}` })
      }
    } else {
      for (const [tf, s] of DOMINGO_NO_TEENS) checks.push({ dia: 'domingo', tf, slot: s })
    }
  }
  return checks
}

function agruparChequeosSabDom (grupo, checks) {
  const esTeens = /TEENS/.test(grupo.grupo || '')
  if (esTeens) return checks.map((c) => ({ modo: 'single', ...c }))
  const buckets = {}
  const resultado = []
  for (const c of checks) {
    if (c.dia !== 'sabado' && c.dia !== 'domingo') {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const w = semanaDesdeSlot(c.slot)
    if (!w) {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const s = String(c.slot).toLowerCase()
    let kind = null
    if (/^lu\d+$|^ma\d+$|^mi\d+$/.test(s)) kind = 'lmm'
    else if (/^ju\d+$|^vi\d+$/.test(s)) kind = 'jv'
    else {
      resultado.push({ modo: 'single', ...c })
      continue
    }
    const key = `${c.dia}|${w}|${kind}`
    if (!buckets[key]) buckets[key] = []
    buckets[key].push(c)
  }
  for (const key of Object.keys(buckets)) {
    const arr = buckets[key]
    const [dia, weekStr, kind] = key.split('|')
    const tf = kind === 'lmm' ? 'id_teacher' : 'id_teacher_2'
    if (arr.length >= 2) {
      resultado.push({ modo: 'grupo', dia, semana: Number(weekStr), kind, tf, slots: arr.map((x) => x.slot) })
    } else {
      arr.forEach((c) => resultado.push({ modo: 'single', ...c }))
    }
  }
  return resultado
}

export default {
  mixins: [funcionesExcel],

  props: {
    dialogCambiosPersonal: { type: Object, required: true },
    gruposFiltrados: { type: Array, default: () => [] },
    teachers: { type: Array, default: () => [] },
    semana: { type: [Number, String], default: 1 },
    cicloLabel: { type: String, default: '' },
  },

  data: () => ({
    search: '',
    headers: [
      { text: 'Grupo', value: 'grupo' },
      { text: 'Plantel', value: 'plantel', width: '110' },
      { text: 'Escuela', value: 'escuela', width: '90' },
      { text: 'Día', value: 'diaLabel', width: '100' },
      { text: 'Slot', value: 'slotLabel', width: '100' },
      { text: 'Teacher oficial', value: 'oficialNombre' },
      { text: 'Teacher actual', value: 'actualNombre' },
    ],
  }),

  computed: {
    /**
     * Resuelve id LMS / trabajador / usuario → { id_usuario, nombre }
     * (misma idea que el backend en getRolClases).
     */
    teachersResolve () {
      const map = new Map()
      const put = (key, idUsuario, nombre) => {
        const k = Number(key)
        if (!k || Number.isNaN(k)) return
        map.set(k, { id: Number(idUsuario), nombre: nombre || '' })
      }
      for (const t of this.teachers || []) {
        if (!t) continue
        const idUsuario = t.id_usuario != null ? Number(t.id_usuario) : 0
        if (!idUsuario) continue
        const nombre = t.nombre_completo || ''
        put(idUsuario, idUsuario, nombre)
        if (t.id_trabajador != null) put(t.id_trabajador, idUsuario, nombre)
        if (t.id_teacher != null) put(t.id_teacher, idUsuario, nombre)
        if (t.iderp != null) put(t.iderp, idUsuario, nombre)
      }
      return map
    },

    analisis () {
      const semana = Number(this.semana) || 1
      const filas = []
      let obligaciones = 0
      let cambios = 0
      let incorrectasKpi = 0
      let idx = 0

      const resolverOficial = (row, tf) => {
        const raw = campoOficial(row, tf)
        if (!raw) return { id: 0, nombre: 'SIN TEACHER' }
        const hit = this.teachersResolve.get(raw)
        if (hit) return { id: hit.id, nombre: hit.nombre || `ID ${hit.id}` }
        // Ya viene como id_usuario en prod
        return { id: raw, nombre: this.nombreTeacher(raw) }
      }

      const esCambioPersonal = (oficialId, actualId) => oficialId > 0 && actualId !== oficialId

      for (const row of this.gruposFiltrados || []) {
        if (!row || Number(row.deleted) === 1) continue
        if (/APOYO/i.test(String(row.grupo || ''))) continue

        const escuela = /FAST/i.test(String(row.grupo || '')) ? 'FAST' : 'INBI'
        const checks = construirChequeos(row)
        const bloques = agruparChequeosSabDom(row, checks).filter((b) => {
          const semanaBloque = b.modo === 'single' ? semanaDesdeSlot(b.slot) : Number(b.semana)
          return semanaBloque === semana
        })

        const bloquesPorDia = {
          lunes: [], martes: [], miercoles: [], jueves: [], viernes: [], sabado: [], domingo: [],
        }
        for (const b of bloques) {
          if (bloquesPorDia[b.dia]) bloquesPorDia[b.dia].push(b)
        }

        const evaluarBloque = (b) => {
          const oficial = resolverOficial(row, b.tf)
          const detalles = []
          let tieneCambio = false
          let sinOficial = !oficial.id

          if (b.modo === 'single') {
            const actual = idNum(row[b.slot])
            if (esCambioPersonal(oficial.id, actual)) {
              tieneCambio = true
              detalles.push({
                slot: b.slot,
                oficial: oficial.id,
                actual,
                oficialNombre: oficial.nombre,
                actualNombre: this.nombreActual(row, b.slot, actual),
              })
            }
            return {
              tieneCambio,
              sinOficial,
              incorrectaKpi: sinOficial || actual !== oficial.id,
              detalles,
            }
          }

          for (const slot of b.slots || []) {
            const actual = idNum(row[slot])
            if (esCambioPersonal(oficial.id, actual)) {
              tieneCambio = true
              detalles.push({
                slot,
                oficial: oficial.id,
                actual,
                oficialNombre: oficial.nombre,
                actualNombre: this.nombreActual(row, slot, actual),
              })
            }
          }
          const algunoDistinto = (b.slots || []).some((slot) => idNum(row[slot]) !== oficial.id)
          return {
            tieneCambio,
            sinOficial,
            incorrectaKpi: sinOficial || algunoDistinto,
            detalles,
          }
        }

        const registrarDia = (dia, lista) => {
          if (!lista.length) return
          obligaciones += 1
          const todosDetalles = []
          let tieneCambio = false
          let incorrectaKpi = false
          const esFinDeSemana = dia === 'sabado' || dia === 'domingo'

          for (const b of lista) {
            const r = evaluarBloque(b)
            if (r.tieneCambio) tieneCambio = true
            if (r.incorrectaKpi) incorrectaKpi = true
            todosDetalles.push(...r.detalles)
          }

          if (incorrectaKpi) incorrectasKpi += 1
          if (!tieneCambio) return

          cambios += 1
          idx += 1

          if (esFinDeSemana) {
            const slotsCambiados = [...new Set(todosDetalles.map((d) => String(d.slot).toUpperCase()))]
            const oficiales = []
            const actuales = []
            for (const d of todosDetalles) {
              const o = d.oficialNombre || 'SIN TEACHER'
              const a = d.actualNombre || 'SIN TEACHER'
              if (!oficiales.includes(o)) oficiales.push(o)
              if (!actuales.includes(a)) actuales.push(a)
            }
            filas.push({
              _key: `${row.iderp || row.id_grupo || idx}-${dia}-${semana}-${idx}`,
              grupo: row.grupo,
              plantel: row.plantel || '',
              escuela,
              dia,
              diaLabel: DIA_LABEL[dia] || dia,
              slot: slotsCambiados.join(','),
              slotLabel: slotsCambiados.length
                ? `${slotsCambiados.join(', ')} (1 clase)`
                : '5 bloques (1 clase)',
              oficialId: todosDetalles[0] ? todosDetalles[0].oficial : 0,
              oficialNombre: oficiales.join(' / ') || 'SIN TEACHER',
              actualId: todosDetalles[0] ? todosDetalles[0].actual : 0,
              actualNombre: actuales.join(' / ') || 'SIN TEACHER',
            })
            return
          }

          for (const d of todosDetalles) {
            idx += 1
            filas.push({
              _key: `${row.iderp || row.id_grupo || idx}-${d.slot}-${idx}`,
              grupo: row.grupo,
              plantel: row.plantel || '',
              escuela,
              dia,
              diaLabel: DIA_LABEL[dia] || dia,
              slot: d.slot,
              slotLabel: String(d.slot).toUpperCase(),
              oficialId: d.oficial,
              oficialNombre: d.oficialNombre || 'SIN TEACHER',
              actualId: d.actual,
              actualNombre: d.actualNombre || 'SIN TEACHER',
            })
          }
        }

        if (row.lunes == 1) registrarDia('lunes', bloquesPorDia.lunes)
        if (row.martes == 1) registrarDia('martes', bloquesPorDia.martes)
        if (row.miercoles == 1) registrarDia('miercoles', bloquesPorDia.miercoles)
        if (row.jueves == 1) registrarDia('jueves', bloquesPorDia.jueves)
        if (row.viernes == 1) registrarDia('viernes', bloquesPorDia.viernes)
        if (row.sabado == 1) registrarDia('sabado', bloquesPorDia.sabado)
        if (row.domingo == 1) registrarDia('domingo', bloquesPorDia.domingo)
      }

      const correctas = Math.max(0, obligaciones - incorrectasKpi)
      const pct = obligaciones ? Number(((correctas / obligaciones) * 100).toFixed(2)) : 0
      return {
        filas,
        resumen: {
          obligaciones,
          cambios,
          correctas,
          pct,
          pctFmt: pct.toFixed(2),
        },
      }
    },

    filasCambios () {
      return this.analisis.filas
    },

    resumen () {
      return this.analisis.resumen
    },
  },

  methods: {
    itemKey (item) {
      return item._key
    },

    nombreTeacher (id) {
      const n = idNum(id)
      if (!n || n === -1 || n === 1202) return 'SIN TEACHER'
      const hit = this.teachersResolve.get(n)
      if (hit && hit.nombre) return hit.nombre
      return `ID ${n}`
    },

    nombreActual (row, slot, actualId) {
      const n = idNum(actualId)
      if (!n || n === -1 || n === 1202) return 'SIN TEACHER'
      const fromSlot = row[`${slot}_n`]
      if (fromSlot) return fromSlot
      return this.nombreTeacher(n)
    },

    exportar () {
      const data = this.filasCambios.map((f) => ({
        Grupo: f.grupo,
        Plantel: f.plantel,
        Escuela: f.escuela,
        Dia: f.diaLabel,
        Slot: f.slotLabel,
        'Teacher oficial': f.oficialNombre,
        'Teacher actual': f.actualNombre,
      }))
      const name = `CAMBIOS_PERSONAL_SEM${this.semana}`
      this.exportExcel(data, name)
    },
  },
}
</script>
